type State = {
    isLoginLoading: boolean
    error: any
}

// what the consumers of useAuthState see: the transient state above plus the derived flags
export type AuthState = State & {
    isInitialLoading: boolean
    isCustomer: boolean
    isCustomerLoading: boolean
    isPartner: boolean
}

export type Action =
    | { type: "REQUEST_LOGIN" }
    | { type: "LOGIN_SUCCESS" }
    | { type: "LOGOUT" }
    | { type: "ERROR"; error?: any }

const initialState: State = {
    isLoginLoading: false,
    error: null,
}

const AuthReducer = (state: State, action: Action): State => {
    switch (action.type) {
        case "REQUEST_LOGIN":
            return {
                ...state,
                isLoginLoading: true,
                error: null,
            }
        case "LOGIN_SUCCESS":
            return {
                ...state,
                isLoginLoading: false,
                error: null,
            }
        case "LOGOUT":
            return {
                ...state,
                isLoginLoading: false,
                error: null,
            }
        case "ERROR":
            return {
                ...state,
                isLoginLoading: false,
                error: action.error,
            }
        default:
            throw new Error("Unhandled action type")
    }
}

export { AuthReducer, initialState }
